import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import Reveal from '@/components/base/Reveal';

export default function ClosingEditorial() {
  return (
    <section aria-labelledby="closing-editorial" className="bg-white pb-12 pt-16 md:pb-16 md:pt-20">
      <Container>
        <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 border-t border-[#E6E6E6] pt-12 md:pt-16 lg:grid-cols-12 lg:gap-x-14">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-[12px] font-medium uppercase tracking-[0.12em] text-[#6B6B6B]">
                COMMON / COMMUNITY CARE
              </p>
            </Reveal>
            <Reveal delay={100}>
              <h2
                id="closing-editorial"
                className="mt-5 font-heading text-[32px] font-semibold leading-[1.15] tracking-[-0.01em] text-[#222222] lg:text-[42px]"
              >
                Care for the places we share.
              </h2>
            </Reveal>
            <Reveal delay={200}>
              <p className="mt-5 max-w-[420px] text-[16px] leading-[1.6] text-[#5F5F5F]">
                Thoughtful property management for the communities people call home.
              </p>
            </Reveal>
            <Link
              to="/contact?type=partnership"
              className="group mt-8 inline-flex cursor-pointer items-center gap-3 whitespace-nowrap border-b border-[#222222] pb-1.5 text-[15px] font-medium text-[#222222] transition-colors duration-200 hover:border-[#79BC68] hover:text-[#4E8A40]"
            >
              Request a Proposal
              <span className="flex h-4 w-4 items-center justify-center transition-transform duration-300 group-hover:translate-x-1.5 motion-reduce:transform-none">
                <i className="ri-arrow-right-line text-[#79BC68]"></i>
              </span>
            </Link>
          </div>

          <div className="lg:col-span-7">
            <Reveal variant="wipe" delay={150}>
              <div className="aspect-[4/3] w-full overflow-hidden rounded-lg bg-[#F2F2F0] lg:aspect-auto lg:h-[420px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/sandbox/1c913ca07941e52081b86c8a3740b23c/759cf317-9e93-466c-ab77-9c2cdeb2bd0f_home-closing.webp"
                  alt="Contemporary residential apartment community under a pale blue sky - property management"
                  title="Residential community managed by COMMON Property Management"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </Container>
    </section>
  );
}